import CycleProgress from './CycleProgress';

export default CycleProgress;
